/** Firebase RTDB permission-denied shapes (logout, rules, write-once). */
export const isRtdbPermissionDenied = (error) =>
  error?.code === "permission-denied" ||
  error?.code === "PERMISSION_DENIED" ||
  error?.message === "Permission denied" ||
  error?.message === "PERMISSION_DENIED: Permission denied";
